// Guarda a escolha do visitante sobre os cookies de estatística (LGPD).
// Valores: 'aceito', 'recusado' ou null (ainda não escolheu).
// Fica salvo só no navegador da pessoa.

const CHAVE = 'colegiolider_consentimento_cookies';
export const EVENTO_CONSENTIMENTO = 'consentimento-cookies-alterado';

export function lerConsentimento() {
  try {
    const valor = window.localStorage.getItem(CHAVE);
    return valor === 'aceito' || valor === 'recusado' ? valor : null;
  } catch (e) {
    return null; // navegador bloqueou o armazenamento: trata como "não escolheu"
  }
}

export function salvarConsentimento(valor) {
  try {
    window.localStorage.setItem(CHAVE, valor);
  } catch (e) {
    // sem armazenamento: a escolha vale só para esta visita
  }
  window.dispatchEvent(new CustomEvent(EVENTO_CONSENTIMENTO, { detail: valor }));
}

export function limparConsentimento() {
  try {
    window.localStorage.removeItem(CHAVE);
  } catch (e) {
    /* nada a fazer */
  }
  window.dispatchEvent(new CustomEvent(EVENTO_CONSENTIMENTO, { detail: null }));
}
